import './Login.scss'

import koalition from '../../../api/koalition.js'
import useFormBuilder from '../../../hooks/FormBuilderHook.js'
import Validators from '../../../forms/Validators.js'
import Input from '../../forms/Input/Input.jsx'
import NewCharacter from '../../modals/NewCharacter/NewCharacter.jsx'
import { useData } from '../../../contexts/Data.js'
import { useToaster } from '../../../contexts/Toaster.js'
import { useNavigate, useSearchParams } from 'react-router'
import { useEffect, useState } from 'react'
import { useModal } from '../../../contexts/Modal.js'
import { env } from '../../../utilities/helpers'
import { useUser } from '../../../contexts/User.js'

const Login = ({}) => {
    const user = useUser()
    const toaster = useToaster()
    const modal = useModal()
    const navigate = useNavigate()
    const [action, setAction] = useState()
    const [searchParams] = useSearchParams()
    const discordCode = searchParams.get('code')
    const discordRedirectUrl = window.location.origin + window.location.pathname
    const discordLoginUrl = `https://discord.com/oauth2/authorize?client_id=${env.DISCORD_CLIENT_ID}&response_type=code&redirect_uri=${discordRedirectUrl}&scope=identify+email`

    const login = () => {
        const formValues = loginForm.$state.value
        formValues.email = formValues.email.toLowerCase().trim()
        koalition.post('/users/login', formValues).then((response) => {
            const jwt = response.data.jwt
            user.login(jwt)
            navigate('/')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const register = () => {
        const formValues = registerForm.$state.value
        formValues.email = formValues.email.toLowerCase().trim()
        koalition.post('/users', formValues).then((response) => {
            const jwt = response.data.jwt
            user.login(jwt)
            navigate('/')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const requestOtp = () => {
        const formValues = otpRequestForm.$state.value
        formValues.email = formValues.email.toLowerCase().trim()

        koalition.post('/users/otp', formValues).then((response) => {
            setAction('recovery')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const recover = () => {
        const formValues = recoveryForm.$state.value
        formValues.email = otpRequestForm.$state.value.email.toLowerCase().trim()

        koalition.post('/users/recover', formValues).then((response) => {
            const jwt = response.data?.jwt
            if (jwt) {
                user.login(jwt)
                navigate('/account')
                toaster.warning(`Access to your account was granted. It's recommended to create a new password for future logins.`)
            }
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const registerForm = useFormBuilder({ onSubmit: register, controls: {
        email: { validators: [Validators.required, Validators.email] },
        password: { validators: [Validators.required] },
    } })

    const otpRequestForm = useFormBuilder({ onSubmit: requestOtp, controls: {
        email: { validators: [Validators.required, Validators.email] },
    } })

    const recoveryForm = useFormBuilder({ onSubmit: recover, controls: {
        otp: { validators: [Validators.required] },
    } })

    const loginForm = useFormBuilder({ onSubmit: login, controls: {
        email: { validators: [Validators.required, Validators.email] },
        password: { validators: [Validators.required] },
    } })

    useEffect(() => {
        if (discordCode) {
            setAction('discordLogin')
            koalition.post('/users/login/discord', { discordCode, redirectUrl: discordRedirectUrl }).then((response) => {
                const jwt = response.data.jwt
                if (jwt) {
                    setAction(null)
                    user.login(jwt)
                    navigate('/')
                }
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
                setAction('login')
            })
        } else {
            setAction('login')
        }
    }, [discordCode])

    return (
        <div className="container-fluid login">
            <div className="row flex-center h-100">
                {action === 'registration' && (
                    <div className="col-md-6 col-xl-4">
                        <h1 className="mb-5">Registration</h1>

                        {registerForm.$state && (
                            <form onSubmit={registerForm.$state.onSubmit}>
                                <main className="row mb-5">
                                    <div className="col-12 mb-3"><Input control={registerForm.$state.controls.email} label="Email" /></div>
                                    <div className="col-12 mb-3"><Input type="password" control={registerForm.$state.controls.password} label="Password" /></div>
                                </main>

                                <footer className="d-flex">
                                    <button type="submit" className="ml-auto primary large" disabled={registerForm.$state.invalid}>Register</button>
                                </footer>
                            </form>
                        )}

                        <p className="flex-center-y mt-5">Already have an account? <button type="button" className="primary medium ml-3" onClick={() => setAction('login')}>Login</button></p>
                    </div>
                )}
                {action === 'otp' && (
                    <div className="col-md-6 col-xl-4">
                        <h1 className="mb-5">Recovery</h1>

                        {otpRequestForm.$state && (
                            <form onSubmit={otpRequestForm.$state.onSubmit}>
                                <main className="row mb-5">
                                    <div className="col-12 mb-3"><Input control={otpRequestForm.$state.controls.email} label="Email" /></div>
                                </main>

                                <footer className="row justify-content-between">
                                    <div className="col-auto">
                                        <button type="button" className="ml-auto primary large outline" onClick={() => setAction('login')}>Back</button>
                                    </div>

                                    <div className="col-auto">
                                        <button type="submit" className="ml-auto primary large" disabled={otpRequestForm.$state.invalid}>Request Otp</button>
                                    </div>
                                </footer>
                            </form>
                        )}
                    </div>
                )}
                {action === 'recovery' && (
                    <div className="col-md-8 col-xl-6">
                        <h1 className="mb-5">Recovery</h1>

                        {recoveryForm.$state && (
                            <form onSubmit={recoveryForm.$state.onSubmit}>
                                <p>An OTP has been sent to {otpRequestForm.$state.value.email}: type it below to access your account.</p>
                                <p className="mb-4">If you don't see the email, make sure you check in the spam folder.</p>

                                <main className="row mb-5">
                                    <div className="col-12 mb-3"><Input control={recoveryForm.$state.controls.otp} label="Otp" /></div>
                                </main>

                                <footer className="row justify-content-between">
                                    <div className="col-auto">
                                        <button type="button" className="ml-auto primary large outline" onClick={() => setAction('otp')}>Back</button>
                                    </div>

                                    <div className="col-auto">
                                        <button type="submit" className="ml-auto primary large" disabled={recoveryForm.$state.invalid}>Recover</button>
                                    </div>
                                </footer>
                            </form>
                        )}
                    </div>
                )}
                {action === 'login' && (
                    <div className="col-md-6 col-xl-4">
                        <h1 className="mb-5">Login</h1>

                        {loginForm.$state && (
                            <form onSubmit={loginForm.$state.onSubmit}>
                                <main className="row mb-3">
                                    <div className="col-12 mb-3"><Input control={loginForm.$state.controls.email} label="Email" /></div>
                                    <div className="col-12 mb-3"><Input type="password" control={loginForm.$state.controls.password} label="Password" /></div>
                                </main>

                                <footer className="d-flex">
                                    <button type="submit" className="ml-auto primary large" disabled={loginForm.$state.invalid}>Login</button>
                                </footer>
                            </form>
                        )}

                        <p className="flex-center-y mt-3">Don't have an account yet? <button type="button" className="primary medium ml-3" onClick={() => setAction('registration')}>Register</button></p>
                        <p className="flex-center-y mt-3">Forgot your password? <button type="button" className="primary medium ml-3" onClick={() => setAction('otp')}>Recover</button></p>

                        <div className="row align-items-center my-4">
                            <div className="col"><hr /></div>
                            <div className="col-auto px-0">or</div>
                            <div className="col"><hr /></div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-auto">
                                <a href={discordLoginUrl} className="discord-login">
                                    <span>Login with Discord</span>
                                    <span className="discord-logo ml-4"><img src="/images/discord_logo.svg" /></span>
                                </a>
                            </div>
                        </div>
                    </div>
                )}
                {action === 'discordLogin' && (
                    <div className="discord-loader">
                        <img src="/images/discord_logo.svg" />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Login